<template>
  <div class="grid grid-cols-3 gap-4">
    <button
      v-for="best in getAvailableBests"
      :key="best.best_id"
      class="relative col-span-1 flex h-20 w-full items-end overflow-hidden rounded-xl p-2"
      @click="openStartDrawer(best.best_id)"
    >
      <img
        :src="`/img/${best.best_symbol.toLowerCase()}.jpg`"
        class="absolute top-1/2 left-0 h-full w-full -translate-y-1/2 transform object-cover"
      />
      <div
        class="absolute inset-0 bg-gradient-to-b from-transparent to-[#2D3748CC]"
      ></div>
      <div class="relative z-10 flex justify-start">
        <span
          class="text-left text-sm font-bold leading-none text-gray-50 drop-shadow"
        >
          {{ best.label }}
        </span>
      </div>
    </button>
    <portal to="modal">
      <best-start-drawer-component
        :active="start_drawer_is_active"
        :data="selected_best"
        @close="start_drawer_is_active = false"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import event_bus from "../../../shared/utils/event_bus";
import symbol_images from "../symbol_images";
import BestStartDrawerComponent from "./best-start-drawer.component.vue";

export default {
  mixins: [symbol_images],

  components: {
    BestStartDrawerComponent,
  },

  data() {
    return {
      start_drawer_is_active: false,
      selected_best: null,
    };
  },

  computed: {
    ...mapGetters({ getAvailableBests: "bests/getAvailableBests" }),
  },

  methods: {
    openStartDrawer(best_id) {
      this.selected_best = this.getAvailableBests.find(
        (item) => item.best_id == best_id
      );
      this.start_drawer_is_active = true;
    },
  },

  mounted() {
    event_bus.$on("BEST_STARTED", () => {
      this.start_drawer_is_active = false;
    });
  },
};
</script>

<style lang="scss" scoped></style>
